import React from "react";

import { NotificationItem } from "./notification-item";
import { useTranslation } from "../../../../hooks";
import { Notification } from "../../../../models";

interface NotificationListProps {
  data: Array<Notification>;
  onClose: (id: string) => void;
}

export const NotificationList: React.FC<NotificationListProps> = ({
  data,
  onClose,
}) => {
  const t = useTranslation();
  return (
    <ul className="notification-list">
      {data.map(({ id, icon, type, message, onClick }) => (
        <NotificationItem
          id={id}
          key={id}
          icon={icon}
          type={type}
          message={t(message)}
          onClose={onClose}
          onClick={onClick}
        />
      ))}
    </ul>
  );
};
